import React from "react"
import classNames from "utils/classNames"

export default function ListTile({
  icon = undefined,
  className = undefined,
  subtitle = undefined,
  title = undefined,
}) {
  return (
    <div className={classNames("grid grid-cols-12 gap-4", className)}>
      <div className="col-span-1">{icon}</div>
      <div className="col-span-10 flex flex-col">
        <span className="text-base vt-highlight">{title}</span>
        <span className="text-sm vt-muted">{subtitle}</span>
      </div>
    </div>
  )
}
